import React from "react";
import useTechCopy from "../useTechCopy";

// Headline and lede stay put on the left while the six areas read as one
// ruled list on the right. A list, because that is what the content is.
export default function DomainsSection() {
  const copy = useTechCopy().domains;

  return (
    <section id="domains" className="relative bg-black px-6 sm:px-10 lg:px-16 py-24 lg:py-32">
      <div className="max-w-[1600px] mx-auto grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-6 lg:sticky lg:top-28">
          <h2 className="font-medium tracking-tighter leading-[0.95] text-white text-[clamp(2.25rem,4.2vw,4rem)]">
            {copy.title[0]}
            <br />
            {copy.title[1]}
          </h2>
          <p className="mt-6 max-w-md text-base lg:text-lg leading-relaxed text-white/80">{copy.lede}</p>
        </div>

        <ul className="lg:col-span-6 border-t border-white/10">
          {copy.items.map((d) => (
            <li
              key={d.title}
              className="grid sm:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] gap-2 sm:gap-8 py-6 border-b border-white/10"
            >
              <h3 className="text-lg font-medium tracking-tight text-white">{d.title}</h3>
              <p className="text-white/70 leading-relaxed">{d.desc}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
